import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom'

import { TokenInterface } from '@store/actionSlices/token'
import { RootStateTypeExtra } from '@store/types'

import { getQueryStringParams } from '@utilities/helper'

import { hasToken } from '@adUtilities/token-helper'

export type PublicRouteProps = {
  authenticatedPath: string
  token: TokenInterface
} & RouteProps

function PublicRoutes({
  authenticatedPath,
  token,
  ...routeProps
}: PublicRouteProps) {
  const location = useLocation()

  const { access_token } = getQueryStringParams(location.search)

  const [isAuthenticated, setIsAuthenticated] = React.useState(false)

  React.useEffect(() => {
    if (hasToken(token)) {
      setIsAuthenticated(true)
    }
  }, [token])

  if (!isAuthenticated || !!access_token) {
    return <Route {...routeProps} />
  }
  return <Redirect to={{ pathname: authenticatedPath }} />
}

export default connect(({ token }: RootStateTypeExtra) => ({
  token,
}))(PublicRoutes)
